export const TeacherEndpoints = {
  Profile: (id: string) => `/v3/teacher/${id}`,
  Reviews: (id: string) => `/v3/comment/teacher/${id}`,
  Ratings: (id: string) => `/v3/comment/teacher/rate/${id}`
} as const
